import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  MainSpouseQuebec2022TaxQuestionnaireOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/quebec-2022-tax-questionnaire/main-spouse-quebec-2022-tax-questionnaire.options';
import { CurrencyEnum } from '@magieno/common';
import { Locale } from '@magieno/common';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import {
  Quebec2022TaxQuestionnaireChildOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/quebec-2022-tax-questionnaire/quebec-2022-tax-questionnaire-child.options';
import {
  PrescriptionDrugInsuranceEnum,
} from '../../../../../../../../../common/src/enums/prescription-drug-insurance.enum';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';
import { CivilStatusEnum } from '../../../../../../../../../common/src/enums/civil-status.enum';
import { differenceInYears } from 'date-fns';
import {
  Quebec2022TaxQuestionnaireBaseOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/quebec-2022-tax-questionnaire/quebec-2022-tax-questionnaire-base.options';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";

@Component({
  selector: 'app-quebec-2022-tax-questionnaire',
  templateUrl: './quebec-2022-tax-questionnaire.component.html',
  styleUrls: ['./quebec-2022-tax-questionnaire.component.scss'],
  standalone: false,
})
export class Quebec2022TaxQuestionnaireComponent {
  @Input()
  public advancedForm: AdvancedForm<MainSpouseQuebec2022TaxQuestionnaireOptions>;

  @Input()
  public baseSpouseForm: AdvancedFormGroup<Quebec2022TaxQuestionnaireBaseOptions>;

  @Input()
  public isMainSpouse: boolean;

  prescriptionDrugInsuranceEnum = PrescriptionDrugInsuranceEnum;
  lifecycleStatusEnum = FormLifecycleStatusEnum;
  civilStatusEnum = CivilStatusEnum;

  isExecuteButtonEnabled: boolean = false;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get birthdayMinDate() {
    return new Date(1900, 0, 1);
  }

  get birthdayMaxDate() {
    return new Date();
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get children(): AdvancedFormArray<Quebec2022TaxQuestionnaireChildOptions> {
    return this.advancedForm.formElements.children as AdvancedFormArray<Quebec2022TaxQuestionnaireChildOptions>;
  }

  calculateAgeOnDecember31(birthDate: Date): number {
    return differenceInYears(new Date(2022, 11, 31, 23), birthDate);
  }

  addChild() {
    this.children.appendNew();
  }

  async removeChild(childIndexToRemove: number) {
    this.children.delete(childIndexToRemove);
    // const modal = this.modalService.open(WarningShareClassDeletionComponent);
    // modal.closed.subscribe(async result => {
    //   if(result === true) {
    //     // Here we delete only in the form, not syncing the change to the server or else deleting could cause bad data to be sync.
    //     this.shareClasses.delete(shareClassIndexToRemove);
    //
    //     return;
    //   }
    // })

    return;
  }
}

